// HANDLE PRODUCTS MEGA MENU
function mmMegaMenuShowProducts(classElemsToHide, classElemToShow, classVideoToHide) {
	var videoWrapper = document.querySelector(classVideoToHide);
	if (videoWrapper) {
		videoWrapper.classList.remove("mm-visible");
		const video = videoWrapper.querySelector("video");
		if (video) {
			video.pause();
		}
	}

	var imageContainers = document.querySelectorAll(classElemsToHide);
	imageContainers.forEach(function (imageContainer) {
		imageContainer.classList.remove("mm-visible");
	});
	document.querySelector(classElemToShow).classList.add("mm-visible");
}

// HANDLE VIDEOS MEGA MENU
function mmMegaMenuShowVideo(classElemsToHide, classVideoToToggle) {
	var productLists = document.querySelectorAll(classElemsToHide);
	productLists.forEach(function (productList) {
		productList.classList.remove("mm-visible");
	});

	var videoWrapper = document.querySelector(classVideoToToggle);
	if (videoWrapper) {
		videoWrapper.classList.add("mm-visible");
		const video = videoWrapper.querySelector("video");
		if (video) {
			video.play();
		}
	}
}

function playVideo(videoToPlay) {
	const video = document.querySelector(videoToPlay);
	if (video) {
		video.play();
	}
	console.log("playing");
}

function pauseVideo(videoToPause) {
	const video = document.querySelector(videoToPause);
	if (video) {
		video.pause();
	}
}

// HANDLE MEGA MENU POSITION
function getMegaMenuPosition() {
	var menuElems = document.querySelectorAll(".mm-header-link");
	var header = document.querySelector(".mm-header");
	var headerHeight = header.offsetHeight;

	menuElems.forEach(function (menuElem) {
		if (menuElem.nextElementSibling) {
			if (menuElem.nextElementSibling.classList.contains("mm-mega-menu-wrapper")) {
				menuElem.nextElementSibling.style.top = `calc(${headerHeight}px)`;
			}
		}
	});
}

// HANDLE MEGA MENU ACTIF
function toggleHeaderClass(header, topHeader) {
	header.addEventListener("mouseenter", function () {
		topHeader.classList.add("mm-header-scrolled");
		this.classList.add("mm-header-scrolled");
	});

	header.addEventListener("mouseleave", function () {
		const drawer = document.querySelector(".mm-drawer-cart-filter");
		const search = document.querySelector(".mm-header-search-container");
		const headerHeight = header.offsetHeight;
		if (!(drawer && drawer.classList.contains("mm-dc-is-open")) && window.scrollY < window.innerHeight - headerHeight && search.classList.contains("mm-close")) {
			topHeader.classList.remove("mm-header-scrolled");
			this.classList.remove("mm-header-scrolled");
		}
		// mmHideSearch();
	});
}

function toggleMegaMenuClass(filter, links, header) {
	links.forEach((link) => {
		link.addEventListener("mouseenter", function () {
			filter.classList.add("active");
			document.querySelector("html").classList.add("stop-scrolling");
		});
	});

	header.addEventListener("mouseleave", function () {
		const drawer = document.querySelector(".mm-drawer-cart-filter");
		if (drawer && drawer.classList.contains("mm-dc-is-open")) {
			filter.classList.add("active");
		} else {
			filter.classList.remove("active");
		}

		document.querySelector("html").classList.remove("stop-scrolling");
	});
}

// MEGA MENU CHANGE ON LINK HOVER
function initCursorDetection() {
	if (window.innerWidth > 992) {
		const announcementBar = document.querySelector(".mm-section-announcement-bar");
		var mmHeader = document.querySelector(".mm-header");
		var logo = document.getElementById("hero_banner_logo");
		const linksMega = document.querySelectorAll(".mm-link-mega-active");
		const MegaMenuFilter = document.querySelector(".mm-filter-mega-menu");

		if (!logo) {
			toggleHeaderClass(mmHeader, announcementBar);
			toggleMegaMenuClass(MegaMenuFilter, linksMega, mmHeader);
			return;
		}

		var logoTop = logo.getBoundingClientRect().top;

		if (!mmHeader) {
			console.log("L'élément n'a pas été trouvé.");
			return;
		}

		if (logoTop >= 20) {
			toggleHeaderClass(mmHeader, announcementBar);
			toggleMegaMenuClass(MegaMenuFilter, linksMega, mmHeader);
		}
	}
}

// MENU ON HOVER
function updateHeaderBackground() {
	var header = document.querySelector(".mm-header");
	var annonceBar = document.querySelector(".mm-section-announcement-bar");
	var logo = document.getElementById("hero_banner_logo");

	if (!logo) {
		function checkScroll() {
			var annonceBarHeight = annonceBar.offsetHeight;

			if (window.scrollY >= annonceBarHeight) {
				header.classList.add("mm-header-scrolled");
			} else {
				header.classList.remove("mm-header-scrolled");
			}
		}
		window.addEventListener("scroll", checkScroll);
		return;
	}

	var logoTop = logo.getBoundingClientRect().top;

	if (logoTop <= 20) {
		header.classList.add("mm-header-scrolled");
	} else {
		header.classList.remove("mm-header-scrolled");
	}
}

// HANDLE MOBILE MENU OPEN
function mmMobileMenu() {
	stopLenis();
	const announcementBar = document.querySelector(".mm-section-announcement-bar");
	const header = document.querySelector("header");
	var headerMenu = document.querySelector(".mm-header");
	var headerHeight = headerMenu.offsetHeight;
	var headerMenuTop = headerMenu.getBoundingClientRect().top;

	const icon = document.querySelector(".mm-header-burger");
	const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
	document.querySelector("html").classList.add("stop-scrolling");

	header.classList.add("mm-open");
	icon.classList.add("mm-open");
	mobileMenu.classList.add("mm-menu-open");
	announcementBar.classList.add("mm-header-scrolled");
	headerMenu.classList.add("mm-header-scrolled");
	mobileMenu.style.top = `calc(${headerHeight}px + ${headerMenuTop}px)`;
}

// HANDLE MOBILE MENU CLOSE
function mmCloseMobileMenu() {
	startLenis();
	const announcementBar = document.querySelector(".mm-section-announcement-bar");
	const header = document.querySelector("header");
	var headerMenu = document.querySelector(".mm-header");
	const icon = document.querySelector(".mm-header-burger");
	const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
	document.querySelector("html").classList.remove("stop-scrolling");

	header.classList.remove("mm-open");
	icon.classList.remove("mm-open");
	mobileMenu.classList.remove("mm-menu-open");

	var headerHeight = header.offsetHeight;

	if (window.scrollY >= window.innerHeight - headerHeight) {
		announcementBar.classList.add("mm-header-scrolled");
		headerMenu.classList.add("mm-header-scrolled");
	} else {
		setTimeout(() => {
			announcementBar.classList.remove("mm-header-scrolled");
			headerMenu.classList.remove("mm-header-scrolled");
		}, "650");
	}
}

// MOBILE MENU - SHOW SOUS MENU
function mmMobileMenuShowNext(elemToShowClass) {
	var elemToShow = document.querySelector(elemToShowClass);
	elemToShow.classList.add("mm-mobile-menu-elem-slided");
}

function mmMobileMenuShowPrev(elemToShowClass) {
	var elemToShow = document.querySelector(elemToShowClass);
	elemToShow.classList.remove("mm-mobile-menu-elem-slided");
}

// HANDLE PRODUCT RECO
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector("product-recommendations");

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.then(productCardSlidersInit)
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
	}
}

// HANDLE SEARCH

function mmShowSearch(trigger) {
  
	// Trouver le conteneur de recherche le plus proche
	const searchContainer = trigger.nextElementSibling;
	const allSearchContainers = document.querySelectorAll(".mm-header-search-container");
	const allSearchTriggers = document.querySelectorAll(".mm-header-icon-search-trigger");
	const searchFilter = document.querySelector(".mm-filter-search"); // Nouveau sélecteur
  
    // Access
    const expanded = trigger.getAttribute("aria-expanded") === "true";
    trigger.setAttribute("aria-expanded", String(!expanded));
    searchContainer.hidden = expanded;

	// Fermer tous les autres conteneurs de recherche
	allSearchContainers.forEach((container) => {
		if (container !== searchContainer) {
			container.classList.add("mm-close");
		}
	});

	// Réinitialiser tous les triggers
	allSearchTriggers.forEach((searchTrigger) => {
		if (searchTrigger !== trigger) {
			searchTrigger.classList.add("mm-close");
		}
	});

	// Basculer l'état du conteneur de recherche actuel
	searchContainer.classList.toggle("mm-close");
	trigger.classList.toggle("mm-close");

	// Gérer le filtre
	if (!searchContainer.classList.contains("mm-close")) {
		searchFilter.classList.add("active");
		document.querySelector("html").classList.add("stop-scrolling");
	} else {
		searchFilter.classList.remove("active");
		document.querySelector("html").classList.remove("stop-scrolling");
	}

	// Focus sur le champ de recherche
	if (!searchContainer.classList.contains("mm-close")) {
		const searchInput = searchContainer.querySelector('input[type="search"]');
		if (searchInput) {
			searchInput.focus();
		}
	}
}

function mmHideSearch() {
	// Sélectionner tous les conteneurs de recherche et triggers
	const searchContainers = document.querySelectorAll(".mm-header-search-container");
	const searchTriggers = document.querySelectorAll(".mm-header-icon-search-trigger");
	const searchFilter = document.querySelector(".mm-filter-search");
	const predictiveSearch = document.querySelector("predictive-search"); // Ajout du sélecteur predictive-search

	// Fermer tous les conteneurs de recherche
	searchContainers.forEach((container) => {
		container.classList.add("mm-close");
	});

	// Réinitialiser tous les triggers
	searchTriggers.forEach((trigger) => {
		trigger.classList.add("mm-close");
	});

	// Désactiver le filtre
	searchFilter.classList.remove("active");
	document.querySelector("html").classList.remove("stop-scrolling");

	// Vider et fermer la recherche prédictive
	if (predictiveSearch) {
		// Dispatch un événement personnalisé pour fermer la recherche prédictive
		predictiveSearch.dispatchEvent(new CustomEvent("clear-search"));

		// Cache le conteneur des résultats
		const resultsContainer = predictiveSearch.querySelector(".predictive-search__results-list");
		if (resultsContainer) {
			resultsContainer.style.display = "none";
		}
	}

	// Vider tous les champs de recherche
	const searchInputs = document.querySelectorAll('input[type="search"]');
	searchInputs.forEach((input) => {
		input.value = "";
	});
}

document.addEventListener("DOMContentLoaded", function () {
	const predictiveSearch = document.querySelector("predictive-search");
	if (predictiveSearch) {
		predictiveSearch.addEventListener("clear-search", function () {
			const input = this.querySelector('input[type="search"]');
			if (input) {
				input.value = "";
				input.dispatchEvent(new Event("input"));
			}
		});
	}
});

function mmDetectHideSearch() {
	const search = document.querySelector(".mm-header-search-container");
	window.addEventListener("scroll", function () {
		if (!search.classList.contains("mm-close")) {
			mmHideSearch();
		}
	});
	window.addEventListener("keydown", function (event) {
		if (event.key === "Escape") {
			mmHideSearch();
		}
	});
}

// FILTERS
function mmShowDrawerInfos(popup, clickedElem) {
	var filter = document.querySelector(".mm-filter-mega-menu");
	document.querySelector(popup).classList.add("mm-dc-is-open");
	document.querySelector("html").classList.add("stop-scrolling");
	clickedElem.classList.toggle("mm-close");

	// Pour accessibility
	document.querySelector('.mm-collection-drawer-container').hidden = false;
	document.querySelector('.mm-collection-drawer-close-icon').focus();
	initFocusTrap(document.querySelector(".mm-collection-drawer-container"), { onEscape: mmHideDrawerInfos });

	if (clickedElem.classList.contains("mm-close")) {
		filter.classList.remove("active");
		filter.style.zIndex = "5";
	} else {
		filter.classList.add("active");
		filter.style.zIndex = "20";
	}
}

function mmHideDrawerInfos(popup) {
	var filter = document.querySelector(".mm-filter-mega-menu");
	document.querySelector(popup).classList.remove("mm-dc-is-open");
	document.querySelector("html").classList.remove("stop-scrolling");
	document.querySelector(".mm-filter-count-container").classList.add("mm-close");
	filter.classList.remove("active");
	filter.style.zIndex = "5";
	productCardSlidersInit();

	// Pour accessibility
	document.querySelector('.mm-collection-drawer-container').hidden = true;
	document.querySelector('#mmFilterCountContainer').focus();
	setTimeout(function() {
		filter.style.zIndex = "0";
	}, 500);
}

// MOBILE DRAWER HEIGHT
const documentHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

// DROPOWN
customElements.define("product-recommendations", ProductRecommendations);

function animatedDropdowns() {
	const faqColl = document.querySelectorAll(".mm-faq-collapsible");
	let q;

	for (q = 0; q < faqColl.length; q++) {
		faqColl[q].addEventListener("click", function () {
			this.classList.toggle("active");

			const content = this.nextElementSibling;

			if (content.style.maxHeight) {
				content.style.maxHeight = null;
			} else {
				content.style.maxHeight = content.scrollHeight + "px";
			}
		});
	}
}

// Target blank External links
function externalLink() {
	var links = document.querySelectorAll("a");
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname !== window.location.hostname && !links[i].hasAttribute('target')) {
			links[i].target = "_blank";
			links[i].rel = "noreferrer noopener";
		}
	}
}

function handleDropdown() {
	const dropWrapper = document.querySelectorAll(".mm-drop-wrapper");

	dropWrapper.forEach((item) => {
		item.addEventListener("click", function () {
			// Close all other dropdowns
			// dropWrapper.forEach((el) => {
			//     if (el !== this) {
			//         el.classList.remove('active');
			//         el.nextElementSibling.style.maxHeight = null;
			//     }
			// });

			// Toggle the current dropdown
			this.classList.toggle("active");

			const content = this.nextElementSibling;

			if (content.style.maxHeight) {
				content.style.maxHeight = null;
			} else {
				content.style.maxHeight = content.scrollHeight + "px";
			}
		});
	});

	// Open the first dropdown by default
	if (dropWrapper.length > 0) {
		const firstDrop = dropWrapper[0];
		firstDrop.classList.add("active");
		const firstContent = firstDrop.nextElementSibling;
		if (firstContent) {
			firstContent.style.maxHeight = firstContent.scrollHeight + "px";
		}
	}
}

document.addEventListener("DOMContentLoaded", (event) => {
	getMegaMenuPosition();
	initCursorDetection();
	mmDetectHideSearch();
	handleDropdown();
	externalLink();
});

window.addEventListener("DOMContentLoaded", (event) => {
	animatedDropdowns();
});

window.addEventListener("scroll", updateHeaderBackground);
window.addEventListener("resize", documentHeight);
documentHeight();

/*---------- ANIMATIONS ----------*/

//scrollTrigger plugin registration
gsap.registerPlugin(ScrollTrigger);

// Déclaration Lenis
var lenis = new Lenis({
	duration: 1.2,
	easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
	direction: "vertical",
	gestureDirection: "vertical",
	lerp: 0.075,
	smooth: 2,
	smoothTouch: false,
	touchMultiplier: 2,
	wheelMultiplier: 1,
	infinite: false,
	autoResize: true,
});

lenis.on("scroll", ({ scroll, limit, velocity, direction, progress }) => {});

var rafId;
function raf(time) {
	lenis.raf(time);
	rafId = requestAnimationFrame(raf);
	ScrollTrigger.update();
}

rafId = requestAnimationFrame(raf);

// Disable Lenis when overing div with overflow:scroll
function stopLenis() {
	// console.log('stop');
	document.querySelector("html").classList.add("stop-scrolling");
	if (rafId) {
		cancelAnimationFrame(rafId);
		rafId = null;
	}
	if (lenis) {
		lenis.destroy();
	}
}

// Fonction appelée quand la souris quitte l'élément
function startLenis() {
	document.querySelector("html").classList.remove("stop-scrolling");
	
	if (lenis) {
		lenis.destroy();
	}
	
	lenis = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		direction: "vertical",
		gestureDirection: "vertical",
		lerp: 0.05,
		smooth: 2,
		smoothTouch: false,
		touchMultiplier: 2,
		wheelMultiplier: 1,
		infinite: false,
		autoResize: true,
	});

	lenis.on("scroll", ({ scroll, limit, velocity, direction, progress }) => {});

	function raf(time) {
		lenis.raf(time);
		rafId = requestAnimationFrame(raf);
		ScrollTrigger.update();
	}

	rafId = requestAnimationFrame(raf);
}

function setupLenis() {
	// Ajout des écouteurs d'événements sur l'élément
	var elements = document.querySelectorAll(".stop-lenis");

	elements.forEach(function (element) {
		if (window.innerWidth > 992) {
			element.addEventListener("mouseenter", stopLenis);
			element.addEventListener("mouseleave", startLenis);
		}
		
		// Empêcher Lenis de capturer les événements wheel sur les éléments scrollables
		element.addEventListener("wheel", function(e) {
			e.stopPropagation();
		}, { passive: false });
	});
}
setupLenis();

// HERO BANNER
const sectionHero = document.querySelector(".mm-section-hero-banner");
if (sectionHero) {
	const logoWrapper = sectionHero.querySelector(".mm-hero-banner-logo-wrapper");
	if (logoWrapper) {
		var logoWidthPixels = window.innerWidth < 1000 ? 72 : 130;
		var start = window.innerWidth < 768 ? "bottom bottom-=15%" : "bottom bottom";

		gsap.to(logoWrapper, {
			y: "-40dvh",
			width: logoWidthPixels,
			ease: "none",
			scrollTrigger: {
				trigger: sectionHero,
				start: start,
				end: "bottom center",
				scrub: 1,
			},
		});
	} else {
		console.log("Le logo n'existe pas");
	}
}

// IMAGE CONTENT ZOOM
const sectionImageContent = document.querySelector(".mm-text-image-content");
if (sectionImageContent) {
	const imageContent = sectionImageContent.querySelector(".mm-image-section-animated-image");
	var startPoint;
	var endPoint;
	if (window.innerWidth < 993) {
		startPoint = "center";
		endPoint = "bottom";
	} else if (window.innerWidth > 1440) {
		startPoint = "top";
		endPoint = "bottom";
	} else {
		startPoint = "center-=20%";
		endPoint = "bottom";
	}
	if (imageContent) {
		gsap.to(imageContent, {
			clipPath: "inset(0% 0%)",
			objectFit: "cover",
			ease: "none",
			scrollTrigger: {
				trigger: sectionImageContent,
				start: `top ${startPoint}`,
				end: `bottom ${endPoint}`,
				scrub: 1,
			},
		});
	} else {
		console.log("L'image n'existe pas");
	}
}

// PARALAX CONTENT PAGE
const images = document.querySelectorAll(".mm-section-ti-parallax");
images.forEach((slideImage) => {
	gsap.to(slideImage.querySelector(".mm-text-image-parrallax-wrapper-1 .mm-section-text-image-parallax-image"), {
		yPercent: -30,
		ease: "none",
		scrollTrigger: {
			trigger: slideImage,
			start: "center bottom",
			end: "center top",
			scrub: true,
		},
	});
	gsap.to(slideImage.querySelector(".mm-text-image-parrallax-wrapper-2 .mm-section-text-image-parallax-image"), {
		yPercent: -15,
		ease: "none",
		scrollTrigger: {
			trigger: slideImage,
			start: "center bottom",
			end: "center top",
			scrub: true,
		},
	});
	gsap.to(slideImage.querySelector(".mm-text-image-parrallax-wrapper-3 .mm-section-text-image-parallax-image"), {
		yPercent: -60,
		ease: "none",
		scrollTrigger: {
			trigger: slideImage,
			start: "center bottom",
			end: "center top",
			scrub: true,
		},
	});
});

// PRODUCT CARDS SLIDERS
function productCardSlidersInit() {
	const sliders = document.querySelectorAll(".mm-pc-slider");

	if (!sliders.length) return;

	sliders.forEach(function (slider) {
		const card = slider.closest(".mm-product-card");
		let isDragging = false;
		let start = 0;
		let end = 0;
		let startY = 0;
		let endY = 0;
		let startTime = 0;
		let images = slider.querySelectorAll(".mm-pc-slider-image");
		let index = 0;
		let progressBar = slider.querySelector(".mm-pc-slider-progress-bar");
		let isDesktop = window.innerWidth >= 769;
		let hasMoved = false;
		let dragged = false;

		// Si il n'y a qu'une seule image, on n'initialise pas les contrôles du slider
		if (images.length <= 1) {
			if (images[0]) {
				images[0].style.opacity = "1";
				images[0].style.pointerEvents = "auto";
			}
			return;
		}
		// Récupérer les boutons de navigation
		const prevButton = slider.querySelector(".mm-pc-slider-prev");
		const nextButton = slider.querySelector(".mm-pc-slider-next");
		const slidesContainer = slider.querySelector(".mm-pc-slides");

		function resetCard() {
			images.forEach((img) => (img.style.opacity = "0"));
			if (progressBar) {
				progressBar.style.width = "0%";
			}
			index = 0;
		}

		function updateImage() {
			if (!images.length) return;

			// Masquer toutes les images immédiatement
			images.forEach((img) => {
				img.style.opacity = "0";
				img.style.pointerEvents = "none";
			});
			
			// Afficher l'image active
			if (images[index]) {
				images[index].style.opacity = "1";
				images[index].style.pointerEvents = "auto";
			}

			if (progressBar) {
				progressBar.style.width = `${((index + 1) / images.length) * 100}%`;
			}
		}

		// Gestion des clics sur les flèches
		if (prevButton) {
			prevButton.addEventListener("click", (e) => {
				e.preventDefault();
				e.stopPropagation();
				index = index - 1 < 0 ? images.length - 1 : index - 1;
				updateImage();
				return false; // Empêche la propagation
			});
		}

		if (nextButton) {
			nextButton.addEventListener("click", (e) => {
				e.preventDefault();
				e.stopPropagation();
				index = (index + 1) % images.length;
				updateImage();
				return false; // Empêche la propagation
			});
		}

		// Empêcher la propagation des clics sur les boutons vers le lien parent
		if (slidesContainer) {
			[prevButton, nextButton].forEach((button) => {
				if (button) {
					button.addEventListener("mousedown", (e) => {
						e.preventDefault();
						e.stopPropagation();
					});

					button.addEventListener("click", (e) => {
						e.preventDefault();
						e.stopPropagation();
					});
				}
			});
			// Ajout : Empêcher le click sur le lien si drag détecté
			slidesContainer.addEventListener("click", function (e) {
				if (dragged) {
					e.preventDefault();
					e.stopPropagation();
					dragged = false;
				}
			});
		}

		function handleDragStart(event) {
			if (event.target.closest(".mm-pc-slider-prev") || event.target.closest(".mm-pc-slider-next")) {
				return;
			}
			isDragging = true;
			hasMoved = false;
			start = event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
			startY = event.type.includes("mouse") ? event.pageY : event.touches[0].clientY;
			startTime = Date.now();
			end = start;
			endY = startY;
		}

		function handleDragging(event) {
			if (!isDragging) return;

			const currentX = event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;
			const currentY = event.type.includes("mouse") ? event.pageY : event.touches[0].clientY;
			const moveDistance = Math.abs(currentX - start);
			const moveDistanceY = Math.abs(currentY - startY);

			if (moveDistance > 5) {
				hasMoved = true;
				dragged = true;
				event.preventDefault();
			}
			// Si le scroll vertical est significatif, on empêche le click
			if (moveDistanceY > 5 && moveDistanceY > moveDistance) {
				dragged = true;
			}

			end = currentX;
			endY = currentY;
		}

		function handleDragEnd(event) {
			if (!isDragging) return;

			const endTime = Date.now();
			const timeElapsed = endTime - startTime;
			const moveDistance = Math.abs(end - start);
			const moveDistanceY = Math.abs(endY - startY);

			isDragging = false;

			// Si le scroll vertical est significatif, on empêche le click
			if (moveDistanceY > 20 && moveDistanceY > moveDistance) {
				dragged = true;
				setTimeout(() => {
					dragged = false;
				}, 0);
				return;
			}

			if (!hasMoved && timeElapsed < 300 && moveDistance < 10) {
				if (event && (event.ctrlKey || event.metaKey)) {
					window.open(card.dataset.url, "_blank");
				} else {
					window.location.href = card.dataset.url;
				}
				setTimeout(() => {
					dragged = false;
				}, 0);
				return;
			}

			const diff = start - end;
			const minSwipeDistance = 30;

			if (Math.abs(diff) >= minSwipeDistance) {
				if (diff > 0) {
					index = (index + 1) % images.length;
				} else {
					index = index - 1 < 0 ? images.length - 1 : index - 1;
				}
				updateImage();
			}
			setTimeout(() => {
				dragged = false;
			}, 0);
		}

		// Mobile
		slider.addEventListener("touchstart", handleDragStart, { passive: true });
		slider.addEventListener("touchmove", handleDragging);
		slider.addEventListener("touchend", handleDragEnd);

		// Desktop
		slider.addEventListener("mousedown", handleDragStart);
		slider.addEventListener("mousemove", handleDragging);
		slider.addEventListener("mouseup", handleDragEnd);
		slider.addEventListener("mouseleave", handleDragEnd);

		if (isDesktop) {
			card.addEventListener("mouseenter", () => {
				index = 1;
				updateImage();
			});

			card.addEventListener("mouseleave", () => {
				resetCard();
			});
		} else {
			updateImage();
		}
	});
}

// SEARCH CARDS SLIDERS
function searchSplideProducts() {
	var id = ".splide-predictive-search";
	var splideElem = document.querySelector(id);
	var bar = splideElem.querySelector(".my-slider-progress-bar");

	var splide = new Splide(splideElem, {
		type: "slide",
		arrows: false,
		pagination: false,
		omitEnd: true,
		gap: 5,
		perPage: 2,
		perMove: 1,
		destroy: true,
		breakpoints: {
			700: {
				destroy: false,
				fixedWidth: 175,
				perPage: false,
				perMove: 2,
			},
		},
	});

	splide.on("mounted move", function () {
		var end = splide.Components.Controller.getEnd() + 1;
		var rate = Math.min((splide.index + 1) / end, 1);
		bar.style.width = String(100 * rate) + "%";
	});

	splide.mount();
}

function checkScreenSizeAndInit() {
	productCardSlidersInit();
}

document.addEventListener("DOMContentLoaded", checkScreenSizeAndInit);
window.addEventListener("resize", checkScreenSizeAndInit);

// SIZE CHART
let lastSizeChartTriggerButton = null;

function mmOpenSC(button, imageUrl, title, price, comparePrice, productId, productUrl = "#") {
  
	const sizeModal = document.querySelector(".mm-size-chart-wrapper");
	
	// Vérifier que le modal existe
	if (!sizeModal) {
		console.error("Le modal du guide des tailles n'a pas été trouvé dans le DOM");
		return;
	}
	
	const closeBtn = sizeModal.querySelector(".mm-sc-close-btn");
	
	// Vérifier que le bouton de fermeture existe
	if (!closeBtn) {
		console.error("Le bouton de fermeture du guide des tailles n'a pas été trouvé");
		return;
	}
	
	// Stocker le bouton qui a ouvert le size chart pour y revenir à la fermeture
	if (button && typeof button.getAttribute === 'function') {
		lastSizeChartTriggerButton = button;
	} else if (button && button.target) {
		lastSizeChartTriggerButton = button.target;
	}

    // Access - Gérer les différents types de paramètres
    if (button && typeof button.setAttribute === 'function') {
        // Si button est un élément DOM valide
        button.setAttribute("aria-expanded", "true");
    } else if (button && button.target && typeof button.target.setAttribute === 'function') {
        // Si button est un événement avec une target
        button.target.setAttribute("aria-expanded", "true");
    }
    
	// Pour accessibility - Retirer hidden AVANT de déclencher l'animation
	sizeModal.hidden = false;
	sizeModal.setAttribute("aria-hidden", "false");	
	
	document.body.style.overflow = "hidden";
	document.querySelector("html").classList.add("stop-scrolling");

	// Mettre à jour les informations du produit seulement si les paramètres sont fournis
	if (imageUrl && title && price) {
		const productImage = document.getElementById("mmSCProductImage");
		const productTitle = document.getElementById("mmSCProductTitle");
		const productPrice = document.getElementById("mmSCProductPrice");
		const productLink = document.getElementById("mmSCProductLink");
		const productComparePrice = document.getElementById("mmSCProductComparePrice");
		const metafieldContentEl = document.getElementById("mmSCMetafieldContent");
		
		if (productImage) {
			productImage.src = imageUrl;
		}
		if (productTitle) {
			productTitle.textContent = title;
		}
		if (productPrice) {
			productPrice.textContent = price;
		}
		if (productLink) {
			productLink.href = productUrl || "#";
		}
		
		if (productComparePrice) {
			if (comparePrice && comparePrice !== price) {
				productComparePrice.textContent = comparePrice;
				productComparePrice.style.display = "block";
			} else {
				productComparePrice.style.display = "none";
			}
		}
		
		// Mettre à jour le contenu metafield via data attribute
		if (productId && metafieldContentEl) {
			const metafieldContent = document.querySelector(`[data-product-metafield="${productId}"]`);
			if (metafieldContent) {
				metafieldContentEl.innerHTML = metafieldContent.innerHTML;
			}
		}
	}

	// Déclencher l'animation après un frame pour que le navigateur applique les styles de base
	requestAnimationFrame(() => {
		sizeModal.classList.remove("mm-hidden");
	});
	
	initFocusTrap(sizeModal, { onEscape: mmCloseSC });
	closeBtn.focus();
}

function mmCloseSC() {
	const sizeModal = document.querySelector(".mm-size-chart-wrapper");
	
	// Retirer le filtre
	document.body.classList.remove("mm-filter-active");
	
	if (window.innerWidth < 768) {
		document.querySelector(".mm-section-header").classList.remove("mm-none");
	}
  
	// Déclencher l'animation de fermeture
	sizeModal.classList.add("mm-hidden");
	document.body.style.overflow = ""; // Réactiver le scroll
	document.querySelector("html").classList.remove("stop-scrolling");
	
	// Attendre la fin de l'animation (600ms) avant d'ajouter hidden
	setTimeout(() => {
		// Access
		sizeModal.hidden = true;
		sizeModal.setAttribute("aria-hidden", "true");
	}, 600);
	
	// Retourner le focus au bouton qui a ouvert le size chart
	if (lastSizeChartTriggerButton) {
		lastSizeChartTriggerButton.focus();
		lastSizeChartTriggerButton = null;
	}
}

function mmCloseSCandAll() {
	mmCloseSC();
	mmCloseD();
}

// Ajout du filtre et ouverture du size chart
function addFilterAndOpenSC(event) {
	document.body.classList.add("mm-filter-active");

	mmOpenSC(event);
}

function afficherTableauMesures() {
	const tableauMesures = document.querySelectorAll(".mm-size-chart-measurements");
	const tableauConversions = document.querySelectorAll(".mm-size-chart-internationnals-conversions");
	const tableauMesuresTitle = document.querySelector(".mm-size-chart-measurements-title");
	const tableauConversionsTitle = document.querySelector(".mm-size-chart-internationnal-title");

	// Afficher les tableaux de mesures et cacher les tableaux de conversions
	tableauMesures.forEach((tableau) => (tableau.style.display = "block"));
	tableauConversions.forEach((tableau) => (tableau.style.display = "none"));

	// Mettre à jour le style des titres
	tableauMesuresTitle.classList.add("mm-underline");
	tableauMesuresTitle.classList.remove("mm-black-20");
	tableauConversionsTitle.classList.add("mm-black-20");
	tableauConversionsTitle.classList.remove("mm-underline");
}

function afficherTableauConversions() {
	const tableauMesures = document.querySelectorAll(".mm-size-chart-measurements");
	const tableauConversions = document.querySelectorAll(".mm-size-chart-internationnals-conversions");
	const tableauMesuresTitle = document.querySelector(".mm-size-chart-measurements-title");
	const tableauConversionsTitle = document.querySelector(".mm-size-chart-internationnal-title");

	// Afficher les tableaux de conversions et cacher les tableaux de mesures
	tableauConversions.forEach((tableau) => (tableau.style.display = "block"));
	tableauMesures.forEach((tableau) => (tableau.style.display = "none"));

	// Mettre à jour le style des titres
	tableauConversionsTitle.classList.add("mm-underline");
	tableauConversionsTitle.classList.remove("mm-black-20");
	tableauMesuresTitle.classList.add("mm-black-20");
	tableauMesuresTitle.classList.remove("mm-underline");
}

// Ajouter les écouteurs d'événements sur les titres
document.querySelector(".mm-size-chart-measurements-title").addEventListener("click", afficherTableauMesures);
document.querySelector(".mm-size-chart-internationnal-title").addEventListener("click", afficherTableauConversions);

// PRODUCT CARD VARIANT SELECTOR MOBILE
function openPCVariantSelector(variantId, productHandle) {
	const selector = document.querySelector(`[data-variant-selector-wrapper="${productHandle}"]`);
	if (selector) {
		selector.classList.remove("mm-hidden");
	}
}

function closePCVariantSelector(productHandle) {
	const selector = document.querySelector(`[data-variant-selector-wrapper="${productHandle}"]`);
	if (selector) {
		selector.classList.add("mm-hidden");

		// Réinitialiser l'opacité de l'image principale après la fermeture
		const card = document.querySelector(`.mm-product-card-${productHandle}`);
		if (card) {
			const slider = card.querySelector(".mm-pc-slider");
			if (slider) {
				const images = slider.querySelectorAll(".mm-pc-slider-image");
				if (images.length > 0) {
					// Réinitialiser toutes les images à opacity 0
					images.forEach((img) => (img.style.opacity = "0"));
					// Mettre la première image à opacity 1
					images[0].style.opacity = "1";
				}
			}
		}
	}
}

// Forcer vidéos en autoplay
// document.addEventListener("DOMContentLoaded", function () {
// 	document.querySelectorAll("video").forEach(video => {
// 	  video.muted = true; // iOS exige que l'autoplay soit muet
// 	  video.play().catch(error => console.log("Autoplay bloqué :", error));
// 	});
// });


// ACCESSIBILITY - Fonction pour gérer l'accessibilité des dropdowns après les mises à jour
function updateDropdownAccessibility() {
    const filterCollapsibles = document.querySelectorAll('.mm-filter-collapsible');
    
    filterCollapsibles.forEach(collapsible => {
        const content = collapsible.nextElementSibling;
        if (content) {
            // Vérifier si le dropdown est ouvert ou fermé
            const isOpen = content.style.maxHeight && content.style.maxHeight !== '0px' && content.style.maxHeight !== 'null';
            
            // Appliquer l'accessibilité appropriée
            setTabbableInside(content, isOpen);
            
            // S'assurer que les inputs checkbox ne sont jamais focusables
            const checkboxes = content.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(checkbox => {
                checkbox.setAttribute('tabindex', '-1');
                checkbox.style.position = 'absolute';
                checkbox.style.opacity = '0';
                checkbox.style.pointerEvents = 'none';
            });
        }
    });
}

// ACCESSIBILITY - Fonction pour réinitialiser l'accessibilité après les mises à jour AJAX
function reinitializeFilterAccessibility() {
    // Réappliquer l'accessibilité des dropdowns
    updateDropdownAccessibility();
    
    // Réappliquer l'accessibilité des inputs checkbox
    ensureCheckboxAccessibility();
    
    // Réinitialiser les événements des dropdowns
    initializeFilterDropdowns();
}

// ACCESSIBILITY - Fonction pour initialiser les dropdowns des filtres
function initializeFilterDropdowns() {
    const filterColl = document.querySelectorAll('.mm-filter-collapsible');
    
    if (filterColl.length === 0) {
        // Si aucun dropdown n'est trouvé, on attend un peu plus
        setTimeout(function() {
            initializeFilterDropdowns();
        }, 100);
        return;
    }
    
    // Initialisation : s'assurer que tous les dropdowns sont correctement configurés
    for (let q = 0; q < filterColl.length; q++) {
        const content = filterColl[q].nextElementSibling;
        
        if (filterColl[q].classList.contains('active')) {
            // Le dropdown est ouvert, on s'assure qu'il est bien configuré
            content.style.maxHeight = content.scrollHeight + 'px';
            setTabbableInside(content, true);
        } else {
            // Le dropdown est fermé
            content.style.maxHeight = null;
            setTabbableInside(content, false);
        }
    }

    // Ajout des écouteurs d'événements pour les clics
    for (let q = 0; q < filterColl.length; q++) {
        // Supprimer les anciens écouteurs pour éviter les doublons
        filterColl[q].removeEventListener('click', handleFilterDropdownClick);
        filterColl[q].addEventListener('click', handleFilterDropdownClick);
    }
}

// ACCESSIBILITY - Gestionnaire d'événements pour les dropdowns
function handleFilterDropdownClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    this.classList.toggle('active');
    const content = this.nextElementSibling;

    if (content.style.maxHeight) {
        content.style.maxHeight = null;
        // Rendre les éléments du dropdown non focusables au clavier
        setTabbableInside(content, false);
    } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        // Rendre les éléments du dropdown focusables au clavier
        setTabbableInside(content, true);
    }
}

// ACCESSIBILITY - Fonctions pour gérer les filtres
function handleFilterKeydown(event, element) {
    // Gérer les touches Entrée et Espace pour activer le filtre
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleFilter(element);
    }
}

function handleFilterClick(event, element) {
    event.preventDefault();
    toggleFilter(element);
}

function toggleFilter(element) {
    const checkbox = element.querySelector('input[type="checkbox"]');
    if (!checkbox || checkbox.disabled) return;

    // Basculer l'état de la checkbox
    checkbox.checked = !checkbox.checked;
    
    // Mettre à jour l'attribut aria-checked
    element.setAttribute('aria-checked', checkbox.checked.toString());
    
    // Ajouter une classe visuelle pour indiquer l'état actif
    if (checkbox.checked) {
        element.classList.add('mm-filter-active');
    } else {
        element.classList.remove('mm-filter-active');
    }
    
    // Déclencher l'événement change sur la checkbox pour activer le filtrage
    const changeEvent = new Event('change', { bubbles: true });
    checkbox.dispatchEvent(changeEvent);
}

// Initialiser les filtres au chargement de la page
document.addEventListener('DOMContentLoaded', function() {
    // Mettre à jour l'état visuel des filtres existants
    const filterWrappers = document.querySelectorAll('.mm-filter-option-wrapper');
    filterWrappers.forEach(wrapper => {
        const checkbox = wrapper.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
            wrapper.classList.add('mm-filter-active');
        }
        
        // S'assurer que l'input checkbox n'est jamais focusable
        if (checkbox) {
            checkbox.setAttribute('tabindex', '-1');
            checkbox.style.position = 'absolute';
            checkbox.style.opacity = '0';
            checkbox.style.pointerEvents = 'none';
        }
    });
    
    // Observer les changements dans le DOM pour s'assurer que les nouveaux filtres respectent l'accessibilité
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        const checkboxes = node.querySelectorAll ? node.querySelectorAll('input[type="checkbox"]') : [];
                        checkboxes.forEach(checkbox => {
                            checkbox.setAttribute('tabindex', '-1');
                            checkbox.style.position = 'absolute';
                            checkbox.style.opacity = '0';
                            checkbox.style.pointerEvents = 'none';
                        });
                    }
                });
            }
        });
    });
    
    // Observer le conteneur des filtres
    const filterContainer = document.querySelector('.mm-filter-wrapper');
    if (filterContainer) {
        observer.observe(filterContainer, {
            childList: true,
            subtree: true
        });
    }
});

// ACCESSIBILITY - Fonction pour gérer le focus trap
// Définie dans mm_access.js

// ACCESSIBILITY - Fonction pour s'assurer que les inputs checkbox ne sont jamais focusables
function ensureCheckboxAccessibility() {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
        // Vérifier si c'est un filtre (pas un input de formulaire normal)
        const isFilterCheckbox = checkbox.closest('.mm-filter-option-wrapper') || 
                                checkbox.closest('.filter-group-display__list-item');
        
        if (isFilterCheckbox) {
            checkbox.setAttribute('tabindex', '-1');
            checkbox.style.position = 'absolute';
            checkbox.style.opacity = '0';
            checkbox.style.pointerEvents = 'none';
        }
    });
}

// Appeler la fonction immédiatement et au chargement
ensureCheckboxAccessibility();
document.addEventListener('DOMContentLoaded', ensureCheckboxAccessibility);
